import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.component.html',
  styles: `
    .custom-grid {
      display: grid;
      grid-template-columns: repeat(3, 120px);
      grid-template-rows: repeat(3, 120px);
      gap: 30px;
      justify-content: center;
      align-items: center;

      @media screen and (max-width: 768px) {
        grid-template-columns: repeat(3, 80px);
        grid-template-rows: repeat(3, 80px);
      }
    }

    .form {
      background-color: #014437;
      width: 100%;
      height: 100%;
      overflow: hidden;

      &.img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .form-md {
      background-color: #014437;
      width: 80%;
      height: 80%;
      overflow: hidden;
    }

    .form-sm {
      background-color: #014437;
      width: 60%;
      height: 60%;
      overflow: hidden;
    }

    .top-left-rounded {
      border-top-left-radius: 60px;
    }
    .top-right-rounded {
      border-top-right-radius: 60px;
    }
    .bottom-left-rounded {
      border-bottom-left-radius: 60px;
    }
    .bottom-right-rounded {
      border-bottom-right-radius: 60px;
    }
    .rounded-all {
      border-radius: 20px;

      @media screen and (max-width: 768px) {
        border-radius: 10px;
      }
    }

    .form.img {
      background: none;
    }

    .custom-img-wrapper-one {
      .bg-shape {
        background-color: #ede1b7;
        z-index: 0;
      }

      img {
        z-index: 1;
      }
    }
    .custom-img-wrapper-two {
      .bg-shape {
        background-color: #ede1b7;
        bottom: 2rem;
        right: 2rem;
        z-index: 0;
      }

      img {
        z-index: 1;
      }
    }
    .nav-tabs .nav-link.active {
      border-bottom: 3px solid #014437;
      font-weight: bold;
      color: #014437;
    }
  `
})
export class AboutComponent {}
